module.exports = __webpack_public_path__ + "static/img/logo_005.aac28330.png";